(function(){
  var d=document,b=d.body;

  function money(cents){
    var fmt=(window.WMNS&&WMNS.moneyFormat)||'${{amount}}';
    var v=(cents/100).toFixed(2);
    var noDec=v.replace(/\.00$/,'');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/,noDec).replace(/\{\{\s*amount\s*\}\}/,v.replace(/\B(?=(\d{3})+(?!\d))/g,',')).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,v.replace('.',','));
  }

  var hdr=d.querySelector('.hdr');
  function onScroll(){ if(hdr) hdr.classList.toggle('is-scrolled', window.scrollY>40); }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

  var burger=d.querySelector('.hdr__burger'), mm=d.querySelector('.mmenu');
  if(burger&&mm){
    burger.addEventListener('click',function(){
      var open=!mm.classList.contains('is-open');
      mm.classList.toggle('is-open',open); hdr.classList.toggle('menu-open',open); b.classList.toggle('menu-open',open);
      burger.setAttribute('aria-expanded',open);
    });
  }

  var els=d.querySelectorAll('[data-reveal]');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){io.observe(el)});
  } else els.forEach(function(el){el.classList.add('is-in')});

  d.querySelectorAll('.hero video').forEach(function(v){
    v.muted=true; var p=v.play&&v.play(); if(p&&p.catch) p.catch(function(){});
    var btn=d.querySelector('[data-sound]');
    if(btn) btn.addEventListener('click',function(){v.muted=!v.muted;btn.textContent=v.muted?'Sound on':'Sound off';});
    if('IntersectionObserver' in window) new IntersectionObserver(function(es){es.forEach(function(e){e.isIntersecting?v.play().catch(function(){}):v.pause();})}).observe(v);
  });

  var sort=d.querySelector('[data-sort]');
  if(sort) sort.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',sort.value);location.href=u.toString();});

  var form=d.querySelector('[data-product-form]');
  var idInput=null;
  if(form){
    var data=JSON.parse(d.getElementById('product-json').textContent);
    idInput=form.querySelector('[name="id"]');
    var btns=d.querySelectorAll('[data-atc]');
    var priceEl=d.querySelector('[data-price]');
    var current=function(){
      var sel=[];form.querySelectorAll('.opt').forEach(function(f){var c=f.querySelector('input:checked');sel.push(c?c.value:null);});
      return {sel:sel,variant:data.variants.find(function(v){return v.options.every(function(o,i){return o===sel[i]});})};
    };
    var update=function(){
      var c=current(),v=c.variant;
      form.querySelectorAll('.opt').forEach(function(f,i){var lab=f.querySelector('legend span');var ch=f.querySelector('input:checked');if(lab)lab.textContent=ch?ch.value:'';
        f.querySelectorAll('input').forEach(function(inp){
          var test=c.sel.slice();test[i]=inp.value;
          var match=data.variants.find(function(vv){return vv.available&&vv.options.every(function(o,j){return test[j]==null||o===test[j]});});
          var l=f.querySelector('label[for="'+inp.id+'"]'); if(l) l.classList.toggle('is-out',!match);
        });
      });
      var ready=c.sel.every(function(s){return s!=null});
      btns.forEach(function(btn){
        if(!ready){btn.disabled=false;btn.textContent='Select a size';btn.dataset.state='select';}
        else if(!v||!v.available){btn.disabled=true;btn.textContent='Sold out';btn.dataset.state='';}
        else{btn.disabled=false;btn.textContent='Add to bag — '+money(v.price);btn.dataset.state='add';}
      });
      if(v){idInput.value=v.id; if(priceEl) priceEl.innerHTML=money(v.price)+(v.compare_at_price>v.price?' <s>'+money(v.compare_at_price)+'</s>':'');
        var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u.toString());}
    };
    form.addEventListener('change',update); update();
    var submit=function(e){
      e.preventDefault();
      var btn=e.currentTarget.tagName==='BUTTON'?e.currentTarget:form.querySelector('[data-atc]');
      if(btn.dataset.state==='select'){form.scrollIntoView({behavior:'smooth',block:'center'});return;}
      if(btn.dataset.state!=='add') return;
      btns.forEach(function(x){x.textContent='Adding…'});
      fetch(WMNS.routes.cartAdd+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+idInput.value,quantity:1}]})})
        .then(function(r){return r.json()}).then(function(){update();openCart();})
        .catch(function(){update();});
    };
    form.addEventListener('submit',submit);
    d.querySelectorAll('.sticky-atc [data-atc]').forEach(function(x){x.addEventListener('click',submit)});

    var gal=d.querySelector('.pdp__gallery'),cnt=d.querySelector('.pdp__count');
    if(gal&&cnt){var n=gal.children.length;gal.addEventListener('scroll',function(){var i=Math.round(gal.scrollLeft/gal.clientWidth)+1;cnt.textContent=i+' / '+n;},{passive:true});}
    var sticky=d.querySelector('.sticky-atc'),mainBtn=form.querySelector('[data-atc]');
    if(sticky&&mainBtn&&'IntersectionObserver' in window){new IntersectionObserver(function(es){sticky.classList.toggle('is-on',!es[0].isIntersecting&&es[0].boundingClientRect.top<0);}).observe(mainBtn);}
  }

  var drawer=d.querySelector('.drawer');
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function render(cart){
    d.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count});
    if(!drawer) return;
    var body=drawer.querySelector('.drawer__body'),foot=drawer.querySelector('.drawer__foot');
    if(!cart.item_count){
      body.innerHTML='<div class="drawer__empty"><p>Your bag is empty.</p><a class="link-u" href="/collections/all">Shop the collection</a></div>';
      foot.hidden=true;return;
    }
    foot.hidden=false;
    body.innerHTML=cart.items.map(function(it,i){
      var img=it.image?it.image.split('?')[0]+'?width=240':'';
      var opts=(it.options_with_values||[]).filter(function(o){return o.value!=='Default Title'}).map(function(o){return esc(o.value)}).join(' / ');
      return '<div class="line"><a class="line__img" href="'+it.url+'">'+(img?'<img src="'+img+'" alt="'+esc(it.product_title)+'" loading="lazy">':'')+'</a><div>'+
        '<div class="line__top"><a href="'+it.url+'">'+esc(it.product_title)+'</a><span>'+money(it.final_line_price)+'</span></div>'+
        (opts?'<div class="line__var">'+opts+'</div>':'')+
        '<div class="line__ctrl"><div class="qty"><button data-q="'+(i+1)+'" data-v="'+(it.quantity-1)+'" aria-label="Decrease">–</button><span>'+it.quantity+'</span><button data-q="'+(i+1)+'" data-v="'+(it.quantity+1)+'" aria-label="Increase">+</button></div>'+
        '<button class="line__rm" data-q="'+(i+1)+'" data-v="0">Remove</button></div></div></div>';
    }).join('');
    drawer.querySelector('[data-subtotal]').innerHTML=money(cart.total_price);
  }
  function refresh(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(render);}
  function openCart(){refresh().then(function(){b.classList.add('cart-open');drawer&&drawer.setAttribute('aria-hidden','false');});}
  function closeCart(){b.classList.remove('cart-open');drawer&&drawer.setAttribute('aria-hidden','true');}
  window.WMNSopenCart=openCart;
  d.querySelectorAll('[data-open-cart]').forEach(function(a){a.addEventListener('click',function(e){if(drawer){e.preventDefault();openCart();}})});
  d.querySelectorAll('[data-close-cart]').forEach(function(a){a.addEventListener('click',closeCart)});
  d.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart()});
  if(drawer) drawer.addEventListener('click',function(e){
    var t=e.target.closest('[data-q]'); if(!t) return;
    fetch(WMNS.routes.cartChange+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:+t.dataset.q,quantity:+t.dataset.v})}).then(function(r){return r.json()}).then(render);
  });
})();
